if (!window.customElements.get('cart-progress')) {
  class CartProgress extends HTMLElement {
    constructor() {
      super();
      this.thresholdOne = parseFloat(this.dataset.giftLimit);
      this.variantId = parseInt(this.dataset.variantId);
    }

    connectedCallback() {
      this.initGWP();
    }

    async initGWP() {
      const cart = await CartProgress.getCartData();
      if (!cart) return;
      await this.testThreshold(cart);
    }

    async testThreshold(cart) {
      this.cartTotal = cart.total_price;
      this.giftInCart = cart.items.find((item) => item.variant_id === this.variantId);
      const updates = this.setUpdates();
      if (Object.keys(updates).length === 0) return;
      await this.autoUpdateCart(updates);
    }

    setUpdates() {
      const updates = {};
      if (this.variantId) {
        if (this.cartTotal >= this.thresholdOne) {
          if (!this.giftInCart) updates[this.variantId] = 1; // add the gift
        } else if (this.giftInCart) {
          updates[this.variantId] = 0; // remove the gift if back below the threshold
        }
      }
      return updates;
    }

    autoUpdateCart(updates) {
      const cartComponent =
        document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      const formData = new FormData();
      Object.entries(updates).forEach(([variantId, quantity]) => {
        formData.append(`updates[${variantId}]`, quantity);
      });

      if (cartComponent?.getSectionsToRender) {
        const sections = cartComponent.getSectionsToRender().map((s) => s.id).filter(Boolean);
        if (sections.length) {
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
          cartComponent.setActiveElement?.(document.activeElement);
        }
      }

      window.__gwpUpdating = true; // flag our own cart write so the watcher below ignores it
      return fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            console.error('GWP cart update failed:', data.errors || data.description);
            return;
          }
          if (!cartComponent) {
            window.location = window.routes.cart_url;
            return;
          }
          cartComponent.renderContents(data);
        })
        .catch((e) => console.error('GWP cart update error:', e))
        .finally(() => {
          window.__gwpUpdating = false;
        });
    }

    static getCartData() {
      return fetch(`${window.routes.cart_url}.js`, { method: 'GET' })
        .then((response) => response.json())
        .catch((error) => {
          console.error('GWP cart fetch error:', error);
          return false;
        });
    }
  }

  window.customElements.define('cart-progress', CartProgress);

  /*
    SUMMER-SALE-2026 gift-add-fix
    The free gift is added when the <cart-progress> element runs (on a cart re-render).
    Third-party upsell apps (e.g. Selleasy) add items their own way and do NOT re-render
    that element, so the gift was never auto-added from the side upsell. This watches
    every cart-changing request and re-runs the gift check so it works no matter how the
    item was added. The check is idempotent — it only adds/removes the gift when needed.
  */
  if (!window.__gwpCartWatch) {
    window.__gwpCartWatch = true;

    const CART_MUTATING = /\/cart\/(add|change|update|clear)/i;
    let busy = false;
    let timer = null;

    const runGiftCheck = () => {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        if (busy || window.__gwpUpdating) return;
        const el = document.querySelector('cart-progress');
        if (!el || !el.variantId) return; // bar not present, or no gift product resolved
        busy = true;
        try {
          const cart = await CartProgress.getCartData();
          if (cart) await el.testThreshold(cart);
        } finally {
          busy = false;
        }
      }, 450);
    };

    const toUrl = (input) => {
      const u = input && input.url ? input.url : input;
      try {
        return String(u || '');
      } catch (e) {
        return '';
      }
    };
    const isCartMutation = (url) => CART_MUTATING.test(url);

    const origFetch = window.fetch;
    window.fetch = function (...args) {
      const url = toUrl(args[0]);
      const out = origFetch.apply(this, args);
      if (isCartMutation(url) && !window.__gwpUpdating) {
        out.then(() => runGiftCheck()).catch(() => {});
      }
      return out;
    };

    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (isCartMutation(toUrl(url))) {
          this.addEventListener('load', () => {
            if (!window.__gwpUpdating) runGiftCheck();
          });
        }
      } catch (e) {
        /* no-op */
      }
      return origOpen.apply(this, arguments);
    };
  }
}
